module.exports = __webpack_public_path__ + "media/images/area/feature/kansai/related/zh-hant/1-4e2f7d2944c6d074f48f17105220829e.jpg";